/**
 * Billing › Print voucher (owner 2026-10-15: "convert into react ankhos").
 * The PHP page saved a voucher nothing ever redeemed and printed it; the
 * owner chose instead a slip printed from a REAL recharge receipt -- what the
 * subscriber paid for, with the provider's terms. Pure HTML, escaped.
 */
export interface VoucherFields {
  provider: string;
  name: string;
  mobile: string;
  plan: string;
  receiptno: string;
  amount: number;
  method: string;
  time: string;
  /** "other": a receipt for non-internet items -- no plan, no internet terms. */
  kind?: "internet" | "other";
  /** The items the receipt is for (its note). */
  items?: string;
}

export const VOUCHER_TERMS = [
  "No refund once a plan is activated.",
  "Each login can be used by the number of devices the plan allows.",
  "The plan runs from activation for the days it states.",
  "The provider is not responsible for any use of the internet prohibited by Indian law.",
];

const esc = (s: string) =>
  s.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[c] ?? c);

export function voucherHtml(v: VoucherFields): string {
  const row = (k: string, val: string) => `<tr><th>${esc(k)}</th><td>${esc(val)}</td></tr>`;
  const other = v.kind === "other";
  const what = other ? row("Items", v.items || "Other items") : row("Plan", v.plan) + (v.items ? row("Items", v.items) : "");
  const terms = other
    ? ""
    : `<p><strong>Terms &amp; conditions</strong></p><ul>${VOUCHER_TERMS.map((t) => `<li>${esc(t)}</li>`).join("")}</ul>`;
  return `<!doctype html><html lang="en"><head><meta charset="utf-8"><title>Voucher ${esc(v.receiptno)}</title>
<style>body{font-family:Arial,sans-serif;max-width:420px;margin:24px auto;color:#111}h1{font-size:20px;margin:0 0 4px}
p.sub{margin:0 0 16px;color:#555;font-size:13px}table{width:100%;border-collapse:collapse;margin-bottom:16px}
th,td{border:1px solid #999;padding:6px 8px;text-align:left;font-size:14px}th{width:38%;background:#f2f2f2}
ul{font-size:12px;padding-left:18px}@media print{button{display:none}}</style></head><body>
<h1>${esc(v.provider)}</h1><p class="sub">${other ? "Receipt" : "Internet voucher"}</p><table>
${row("Name", v.name)}${row("Mobile", v.mobile)}${what}${row("Receipt no.", v.receiptno)}${row("Amount", `Rs. ${Number.isInteger(v.amount) ? v.amount : v.amount.toFixed(2)} (${v.method})`)}${row("Date", `${v.time} IST`)}
</table>${terms}
<button onclick="window.print()">Print</button></body></html>`;
}

/** Opens the slip in its own window and prints it; false when a popup blocker stopped it. */
export function printVoucher(v: VoucherFields): boolean {
  const w = window.open("", "_blank", "width=480,height=640");
  if (!w) return false;
  w.document.open();
  w.document.write(voucherHtml(v));
  w.document.close();
  w.focus();
  w.print();
  return true;
}
